import { acceptUserInvitePath } from "../../hh_platform_frontend/docs/app/app.paths";

export function loginPagePath() {
  return 'auth/login';
}

// these backend (!) routes require no auth
export function noAuthNeededPaths() {
  return [
    'api/auth/local',
    'api/auth/local/register',
    'api/clients/login/'
  ];
}

/*
* For these routes, being logged in shall not be required.
*/
export const publicAppRoutes: Array<string> = [
  '/auth/login',
  '/login',
  '/auth/instanceSelection',
  '/',
  '/userLogin',
  '/userLogin/',
  `${acceptUserInvitePath()}`,
  '/forgot-password',
  '/reset-password',
  '/confirm',
  '/callbacks/oidc' /* , '/auth/register', '/auth/logout',  */];

/*
* Strip query string and fragment so a URL like `/callbacks/oidc?medicusUser=xxx`
* matches the public route entry `/callbacks/oidc`.
*/
export function isPublicAppRoute(url: string): boolean {
  if (!url) return false;
  const pathOnly = url.split('?')[0].split('#')[0];
  return publicAppRoutes.includes(pathOnly);
}
